import React from 'react';

import { Svg } from '@lglp/components';

import styles from './Arrow.module.scss';

export enum ArrowOrientation {
  TOP,
  LEFT,
  RIGHT,
  BOTTOM,
}

const Arrow: React.FC<ArrowProps> = (props) => {
  const { orientation = ArrowOrientation.RIGHT, className, ...rest } = props;

  let orientationClassName = styles.right;
  switch (orientation) {
    case ArrowOrientation.LEFT: {
      orientationClassName = styles.left;
      break;
    }
    case ArrowOrientation.TOP: {
      orientationClassName = styles.top;
      break;
    }
    case ArrowOrientation.BOTTOM: {
      orientationClassName = styles.bottom;
      break;
    }
    case ArrowOrientation.RIGHT:
    default: {
      orientationClassName = styles.right;
      break;
    }
  }

  return (
    <Svg
      className={[styles.arrow, orientationClassName, className]}
      viewBox="0 0 17.593 17.646"
      {...rest}
    >
      <path
        className={styles.line}
        transform="translate(0 8.823)"
        d="M0 0h16"
      />
      <path d="m5 21 7-8-7-8" transform="translate(3.932 -4.177)" />
    </Svg>
  );
};

type ArrowProps = {
  orientation?: ArrowOrientation;
  className?: string;
};

export default Arrow;
